import Vue from 'vue';
import VueRouter from 'vue-router';

import "ant-design-vue/dist/antd.css";

// const isDebugMode = process.env.NODE_ENV !== 'production';
const isDebugMode = true
Vue.config.debug = isDebugMode;
Vue.config.devtools = isDebugMode;
Vue.config.productionTip = isDebugMode;

import App from './App.vue';

import Login from "./components/Login.vue"
import Home from "./components/Home.vue"
import { monitorInputEvent } from "./event/input.js"
import store from "./store/index"

Vue.use(VueRouter)

monitorInputEvent()

let router = new VueRouter({
    routes: [
        { path: '/',
          component: Login,
          meta: {
              title: '数据标注系统'
          }
        },
        { path: '/home',
          component: Home,
          meta: {
              title: '数据标注系统'
          }
        },
    ]
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    next();
})

new Vue({
    el: '#app',
    router: router,
    store,
    render: c => c(App),
})
